var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/dashboard",
        pageTitle: "Leads",
        backLink: "/dashboard/reports",
        hasFab: "",
        fabClasses: _vm.$page.props.crmClient?.id
          ? "leads-fab"
          : "leads-fab-hide",
      },
      on: {
        fabAction: function ($event) {
          _vm.manageLead = true
        },
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      subtitle: _vm.allLocations
                        ? "Leads By Location"
                        : `${_vm.selectedLocation.name} Leads`,
                      allLocations: _vm.allLocations,
                      locationOptions: "",
                      selectedLocation: _vm.selectedLocation,
                      filter: "",
                      dateRange: _vm.dateRange,
                      reportUrl: "/dashboard/reports/leads",
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "filterItem",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item",
                              { staticClass: "flex justify-center pb-1" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "flex soli-round soli-grey",
                                    attrs: { ripple: false, outlined: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.$inertia.reload({
                                          data: {
                                            activeLeads: Number(
                                              !_vm.activeLeads
                                            ),
                                          },
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c("small", { staticClass: "mr-2" }, [
                                      _vm._v("View Current Leads"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: _vm.activeLeads
                                            ? "accent"
                                            : null,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activeLeads
                                              ? "toggle_on"
                                              : "toggle_off"
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    staticClass: "cursor-pointer",
                    attrs: {
                      "item-key": "key",
                      headers: _vm.headers,
                      items: _vm.leads,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      search: _vm.search,
                      groupBy: _vm.allLocations ? "location" : null,
                    },
                    on: {
                      "current-items": function ($event) {
                        return _vm.collapse()
                      },
                      "click:row": function ($event) {
                        return _vm.handleLeadSelection($event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `group.header`,
                          fn: function ({ group, items, isOpen, toggle }) {
                            return [
                              _c(
                                "th",
                                { attrs: { colspan: _vm.headers.length } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "flex justify-start align-center pa-2",
                                      attrs: { "no-gutters": "" },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-3",
                                          on: { click: toggle },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(isOpen ? "remove" : "add") +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "soli-grey text-subtitle-2 font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(group) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "soli-grey text-small",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        • " +
                                                _vm._s(items.length) +
                                                " Lead(s)\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "soli-grey text-small",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        •\n                                        " +
                                                _vm._s(
                                                  `${
                                                    _vm.meta.find(
                                                      (e) => e.location == group
                                                    )?.conversion
                                                  } Conversion`
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center py-2 soli-grey",
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      item.user_id
                                        ? _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.user_id}/account`,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.name) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.name) +
                                                "\n                                "
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      item.email
                                        ? _c(
                                            "v-list-item-subtitle",
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.email) +
                                                  "\n                                    "
                                              ),
                                              _c("Clipboard", {
                                                attrs: {
                                                  text: item.email,
                                                  label: "Copy Email",
                                                  "x-small": "",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.status.value`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "font-bold text-capitalize",
                                  attrs: {
                                    small: "",
                                    color: item.status?.color ?? "dark",
                                  },
                                },
                                [_vm._v(_vm._s(item.status.value))]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.workflow`,
                          fn: function ({ item }) {
                            return [
                              item.workflow
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col gap-1",
                                      staticStyle: {
                                        "max-width": "120px !important",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "caption soli-grey whitespace-nowrap text-ellipsis overflow-hidden",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.workflow.name) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-progress-linear", {
                                        attrs: {
                                          value: item.workflow.progress?.stat,
                                          color: "secondary",
                                          height: "6",
                                          rounded: "",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: `item.resume`,
                          fn: function ({ item }) {
                            return [
                              item.resume
                                ? _c("Clipboard", {
                                    attrs: {
                                      text: item.resume,
                                      label: "Copy link",
                                      "x-small": "",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.manageLead
        ? _c("ManageLead", {
            attrs: { leadId: _vm.selection, errors: _vm.$page.props.errors },
            on: {
              reset: function ($event) {
                return _vm.closeManageLead()
              },
              success: function ($event) {
                ;[(_vm.$refs.layout.showMessage = true), _vm.closeManageLead()]
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }